<script>
export default {
  name: 'FeedbackWrapper',
  props: {
    noData: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: 'Este gráfico não está disponível no momento!',
    },
    withBorder: {
      type: Boolean,
      default: false,
    },
    withBoxShadow: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    // Remove a sombra do card `bordered` (borda hairline apenas). Backward
    // compatible: default false mantém o `--shadow-sm` do DS nos consumidores atuais.
    noShadow: {
      type: Boolean,
      default: false,
    },
    flatGray: {
      type: Boolean,
      default: false,
    },
    minHeight: {
      type: [String, Number],
      default: 400,
    },
    title: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: 'az-title-card',
    },
    iconName: {
      type: String,
      default: 'warning-status',
    },
    iconColor: {
      type: String,
      default: 'warning-new',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    normalizedMinHeight() {
      return typeof this.minHeight === 'number'
        ? `${this.minHeight}px`
        : this.minHeight || 'auto'
    },
    feedbackStyles() {
      return {
        class: {
          'd-flex': true,
          'align-center': true,
          'justify-center': true,
          'feedback-wrapper': true,
          'with-border': this.withBorder,
          'az-card-bordered no-padding': this.bordered,
          'no-shadow': this.bordered && this.noShadow,
          'az-card no-padding rounded-sm': this.withBoxShadow,
          'flat-gray rounded-sm': this.flatGray,
        },
        style: {
          minHeight: this.normalizedMinHeight,
        },
      }
    },
    feedbackSkeleton() {
      return {
        class: {
          'feedback-wrapper': true,
        },
        style: {
          minHeight: this.normalizedMinHeight,
        },
        height: this.normalizedMinHeight,
      }
    },
    buttonWrapperClasses() {
      return {
        'd-flex': true,
        'justify-center': true,
        'mt-4': !!this.$slots.button,
      }
    },
    hasContentSlot() {
      return (
        !!this.$slots.content ||
        !!(this.$scopedSlots && this.$scopedSlots.content)
      )
    },
  },
}
</script>

<template>
  <div v-if="noData || loading" v-bind="feedbackStyles">
    <div v-if="title" :class="['feedback-title', titleClass]">
      {{ title }}
    </div>

    <BaseLoadingSkeleton
      v-if="loading"
      v-bind="feedbackSkeleton"
      width="100%"
    />
    <div
      v-else-if="noData && !loading"
      class="feedback-content pa-4 d-flex flex-column"
    >
      <icon-svg size="40" class="mb-4" :name="iconName" :color="iconColor" />
      <template v-if="hasContentSlot">
        <slot name="content" />
      </template>

      <template v-else>
        <p v-if="message" class="ma-0 feedback-message"> {{ message }} </p>
        <div :class="buttonWrapperClasses">
          <slot name="button" />
        </div>
      </template>
    </div>
  </div>

  <div v-else class="slot-wrapper">
    <slot />
  </div>
</template>

<style lang="sass" scoped>
.slot-wrapper
  display: contents

.feedback-wrapper
  position: relative
  flex-grow: 1 !important
  height: 100% !important
  width: 100% !important

  &.with-border
    // Mesma skin dos cards do DS (az-card-bordered): branco, borda hairline,
    // raio e sombra leve — antes usava um cinza hardcoded (#CECECECC).
    background-color: #fff !important
    border-radius: var(--radius-card) !important
    border: solid 1px var(--border-hairline) !important
    box-shadow: var(--shadow-sm) !important
  &.flat-gray
    background-color: #F0F1F3 !important

  // Skeleton de loading arredondado como os cards do DS (antes 6px).
  ::v-deep .base-loading-skeleton
    border-radius: var(--radius-card) !important
    &::before
      border-radius: var(--radius-card) !important

.feedback-title
  position: absolute
  top: 32px
  left: 32px
  right: 32px
  text-transform: none !important

.feedback-content
  width: 100%
  max-width: inherit

.feedback-message
  font-family: 'Geist'
  font-size: 16px
  color: #545454
  font-weight: 400
  line-height: 1.2
  text-align: center
</style>
